import styled from 'styled-components'

export const ZoomInOutWrapper = styled.div`
  display: flex;
  max-width: 200px;
  padding: 10px;
  gap: 14px;
  align-items: center;

  svg {
    cursor: pointer;
  }
`

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  cursor: pointer;
  svg {
    width: 100%;
    height: 100%;
  }
`
